import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HocModule } from '@hoc/hoc.module';
import { NgxTranslateModule } from '@modules/translate/translate.module';
import { EbcontGalaxyModule, GalaxyDialogService, GalaxyInjectorKeys, GalaxyLoggingService, GalaxySettingsService, GalaxyToastService, GxBreadcrumbsComponent } from '@ebcont/ebcont.galaxy.js';
import { InjectorKeys } from '@core/utils/injector.keys';
import { ApplicationConfigurationService } from '@core/services/configuration/application.configuration.service';
import { environment } from '@env/environment';
import { TeamModule } from '@modules/team/team.module';
import { ProjectModule } from '@modules/project/project.module';
import { SkillModule } from '@modules/skill/skill.module';
import { LinksModule } from '@modules/useful/links.module';
import { CustomerModule } from '@modules/customer/customer.module';
import { CoreModule } from '@core/core.module';
import { AuthModule } from '@core/auth/auth.module';
import { HttpClientModule } from '@angular/common/http';
import { FeatureToggleService } from '@core/services/feature-toggle/feature.service';
import { Injector } from '@angular/core';
import { OverviewModule } from '@modules/overview/overview.module';

export function loadToggles(ftService: FeatureToggleService) {
  return () => ftService.loadToggles();
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    NgxTranslateModule,
    FontAwesomeModule,
    EbcontGalaxyModule,
    HocModule,
    TeamModule,
    ProjectModule,
    SkillModule,
    LinksModule,
    CustomerModule,
    CoreModule,
    OverviewModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: GalaxyInjectorKeys.LOGGING, useClass: GalaxyLoggingService },
    { provide: GalaxyInjectorKeys.SETTINGS, useClass: GalaxySettingsService },
    { provide: InjectorKeys.ENVIRONMENT, useValue: environment },
    { provide: InjectorKeys.CONFIGURATION, useClass: ApplicationConfigurationService },
    GalaxyDialogService,
    GalaxyToastService,
    GxBreadcrumbsComponent,
    { provide: APP_INITIALIZER, useFactory: loadToggles, deps: [FeatureToggleService], multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
